import React from 'react'
import Form from '../Form'
import logo from '../../assets/fierj-logo.svg'
import logoDenuncias from '../../assets/denunciASonline_logo.svg'

import './index.scss'

const FormSection = () => {
  return (
    <section className='form__section'>
      <header className='form__section__header'>
        <img className='logo__denuncias' src={logoDenuncias} alt='Logo da plataforma' />
        <img className='logo' src={logo} alt='Logo Fierj' />
      </header>
      <div className='form__section__bg'>
        <p className='form__section__text'>
          A FIERJ, preocupada com a disseminação do antissemitismo, particularmente através das
          redes sociais, criou este canal para receber as denúncias de publicações com conteúdo
          discriminatório contra o povo judeu. <br />
          <br /> Se você encontrou alguma publicação que considera ser uma clara ofensa e ameaça aos
          judeus, encerrando um discurso de incitação à violência e ao ódio, DENUNCIE AQUI! <br />{' '}
          <br />
          Nós iremos tomar as medidas cabíveis para combater, de forma legal, toda e qualquer
          situação de violação da lei brasileira, que considera a disseminação de ideias
          preconceituosas e/ou discriminatórias contra a comunidade judaica um crime de racismo.{' '}
          <br /> <br /> Você será informado através de seu e-mail sobre o andamento da sua denúncia.
        </p>
        <h1 className='form__section__title'>Juntos contra o antissemitismo!</h1>
        <div className='form__container'></div>
        <Form />
        <div className='form__darker_bg'></div>
        <div className='form__links'>
          <a href='./FIERJ_Termos_e_Condicoes_de_Uso_LF_27.10.2023.pdf' target='_blank'>
            Termos e condições de uso
          </a>
          <div>
            <p>powered by </p>
            <a href='https://www.semprocesso.com.br/' target='_blank' rel='noreferrer'>
              sem processo
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FormSection
